import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {loadStripe, Stripe, StripeCardElement, StripeElements} from "@stripe/stripe-js";
import {environment} from "../../../../../../environments/environment";
import {PaymentHttpService} from "../../../../../services/http-services/payment/payment-http.service";
import {NgIf} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {UserRoles} from "../../../../../enums/general-enums";
import {AuthenticationHelperService} from "../../../../../services/helpers/authentication-helper.service";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'tl-payment',
  standalone: true,
  imports: [
    NgIf,
    TranslateModule
  ],
  templateUrl: './payment.component.html',
})
export class PaymentComponent {
  @Input() plan: any;
  @Input() currentPlan: any;
  @Output() planUpgraded: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('cardElement') cardElement!: ElementRef;
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  card: StripeCardElement | null = null;
  isPaymentProcessing = false;
  errorMessage = '';

  constructor(private paymentHttpService: PaymentHttpService,
              private authHelperService: AuthenticationHelperService,
              private toastService: ToastrService) {
  }

  async ngOnInit(): Promise<void> {
    this.stripe = await loadStripe(environment.STRIPE_KEY);
    if (this.stripe) {
      this.elements = this.stripe.elements();
      this.card = this.elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            color: '#ffffff',
            lineHeight: '50px',
            fontFamily: '"Archivo Regular, Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#808080'
            }
          },
          invalid: {
            color: '#df1b41',
            iconColor: '#df1b41'
          }
        }
      });
      this.card.mount(this.cardElement.nativeElement);
    }
  }

  async handleSubscription(): Promise<void> {
    if (!this.stripe || !this.card) {
      return;
    }
    this.isPaymentProcessing = true;
    this.errorMessage = '';
    const {paymentMethod, error} = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.card,
    });

    if (error) {
      this.errorMessage = error.message || 'Something went wrong while processing your payment. Please try again.';
      this.isPaymentProcessing = false;
      return;
    }

    if (paymentMethod) {
      if (this.currentPlan && 'tlalister' === this.currentPlan.plan) {
        this.paymentHttpService.upgradeSubscriptionPlan({
          old_plan_id: this.currentPlan.plan,
          new_plan_id: this.plan.planId,
          payment_method_id: paymentMethod.id
        }).then(res => {
          if (res.code === 200) {
            this.authHelperService.setUserData(res.data);
            this.isPaymentProcessing = false;
            this.toastService.success(res.message);
            this.planUpgraded.emit();
          }
        }).catch(error => {
          this.errorMessage = error.message;
          this.isPaymentProcessing = false;
        });
      } else {
        this.paymentHttpService.setSubscriptionPlan({
          plan_id: this.plan.planId,
          payment_method_id: paymentMethod.id
        }).then(res => {
          if (res.code === 200) {
            this.authHelperService.setUserData(res.data);
            this.isPaymentProcessing = false;
            this.toastService.success(res.message);
            this.planUpgraded.emit();
          }
        }).catch(error => {
          this.errorMessage = error.message;
          this.isPaymentProcessing = false;
        });
      }
    }
  }
}
